import { CreateBindingFarmerPayload, CreateBindingConsultantPayload } from "@practium/features/users"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import api from "../../http"
import { useForBindingId } from '../../../forBinding'
import { getApiErrorMessage, toApiError } from "../utils"

interface UsePostBindingUserParams {
    bindingType: number;
}

export const usePostBindingUser = ({ bindingType }: UsePostBindingUserParams) => {
    const queryClient = useQueryClient()
    const forBinding = useForBindingId();
    return useMutation({
        mutationFn: async (payload: CreateBindingFarmerPayload | CreateBindingConsultantPayload) => {
            try {
                return (await api.post(`/binding-user/create/${bindingType}`, payload, {
                    params: { forBinding },
                })).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao vincular usuário');
            }
        },
        onSuccess: () => { queryClient.invalidateQueries({ queryKey: ['binding-users'] }) },
        onError: (error) => {
            console.error('Erro ao vincular usuário:', getApiErrorMessage(error, 'Erro ao vincular usuário'))
        }
    })
}
